export abstract class AbstractDataAdapter<I, O> {
    protected data: I;
    public constructor(data: I) {
        this.data = data;
    }
    abstract adapt(): Promise<O>;
}